"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("../utils/object");
var Base_1 = require("../Base");
var Tealium_1 = require("../Tealium");
exports.default = new (/** @class */ (function (_super) {
    __extends(AudioMonitor, _super);
    function AudioMonitor() {
        var _this = _super.call(this) || this;
        _this.instance = null;
        _this.state = {
            audio: {
                name: null,
                volume: 1,
                playerState: null,
                audioItem: null,
            },
        };
        _this.debug = true;
        _this.init = function (options) {
            if (!options) {
                return _this.error("options need to be provided");
            }
            if (!window.utag) {
                _this.warn("utag needs to be loaded in order to use AudioMonitor library");
            }
            _this.options = options;
            _this.setupInstance(options.id, options.instance);
        };
        _this.setupInstance = function (id, instance) {
            _this.instance = instance;
            if (!_this.instance) {
                _this.warn("No AudioPlayer instance found!");
                return;
            }
            _this.subscribeToEvents(id);
        };
        _this.subscribeToEvents = function (id) {
            _this.info("subscribe to events from audio player %c".concat(id, ":"), "font-weight:bold", "\n".concat(Object.keys(_this.events).join(", ")));
            Object.keys(_this.events).forEach(function (eventKey) {
                var key = eventKey;
                _this.subscribe(key, _this.eventWrapper(_this.events[key]));
            });
        };
        _this.sendEvent = function (event) { return _this.eventWrapper(function () { return event; })({}); };
        _this.unsubscribe = function (off, func) {
            if (!_this.instance)
                return;
            _this.instance.off(off, func);
        };
        _this.unsubscribeFromEvents = function () {
            Object.keys(_this.events).forEach(function (eventKey) {
                var key = eventKey;
                _this.unsubscribe(key, _this.events[key]);
            });
            _this.instance = null;
        };
        _this.subscribe = function (on, func) {
            if (!_this.instance)
                return;
            _this.instance.on(on, func);
        };
        _this.eventWrapper = function (callback) { return function (event) {
            // Collect all the necessary data for the track event
            var collectCallbackData = callback(event);
            var trackData = _this.getTrackData();
            var event_action = collectCallbackData.event_action;
            var eventData = __assign(__assign(__assign({}, trackData), { event_name: "player_".concat(event_action) }), collectCallbackData);
            Tealium_1.default.link(eventData);
        }; };
        _this.getTrackData = function () {
            var audioData = {};
            audioData = {
                media_type: "audio",
                event_category: "player",
            };
            (0, object_1.deleteNullValues)(audioData);
            return audioData;
        };
        _this.onIdle = function () {
            _this.state.audio.playerState = "stop";
            return {
                event_action: "stop",
            };
        };
        _this.onBeforePlay = function () {
            _this.state.audio.playerState = "play";
            return {
                event_action: "play",
            };
        };
        _this.onPlay = function () {
            if (_this.state.audio.playerState === "pause") {
                _this.state.audio.playerState = "play";
                return {
                    event_action: "resume",
                };
            }
            if (_this.state.audio.playerState === "play") {
                _this.state.audio.playerState = "start";
                return {
                    event_action: "start",
                };
            }
            return false;
        };
        _this.onMute = function () {
            _this.state.audio.playerState = "mute";
            _this.state.audio.volume = 0;
            return {
                event_label: "mute",
                event_action: "volume",
                event_value: "",
            };
        };
        _this.onAudioItem = function (item) {
            _this.state.audio.audioItem = item;
            return false;
        };
        _this.onSeek = function () {
            if (_this.state.audio.playerState === "pause" || _this.state.audio.playerState === "play") {
                _this.state.audio.playerState = "seek";
                return {
                    event_action: "seek",
                };
            }
            return false;
        };
        _this.onSeeked = function () {
            if (_this.state.audio.playerState === "seek") {
                _this.state.audio.playerState = "seeked";
                return {
                    event_action: "seeked",
                };
            }
            return false;
        };
        _this.onPause = function () {
            if (_this.state.audio.playerState === "play" || _this.state.audio.playerState === "start") {
                _this.state.audio.playerState = "pause";
                return {
                    event_action: "pause",
                };
            }
            return false;
        };
        _this.onStop = function () {
            if (_this.state.audio.playerState === "stop")
                return false;
            _this.state.audio.playerState = "stop";
            return {
                event_action: "stop",
            };
        };
        _this.onComplete = function () {
            if (_this.state.audio.playerState === "complete")
                return false;
            _this.state.audio.playerState = "complete";
            return {
                event_action: "complete",
            };
        };
        _this.onPlayerVolumeChange = function (event) {
            var volumeState = event.volume > _this.state.audio.volume ? "up" : "down";
            _this.state.audio.volume = event.volume;
            return {
                event_value: event.volume,
                event_label: volumeState,
                event_action: "volume",
            };
        };
        _this.onError = function () {
            return {
                event_action: "error",
            };
        };
        _this.name = "AudioMonitor";
        _this.events = {
            idle: _this.onIdle,
            beforePlay: _this.onBeforePlay,
            mute: _this.onMute,
            play: _this.onPlay,
            audioItem: _this.onAudioItem,
            seek: _this.onSeek,
            seeked: _this.onSeeked,
            pause: _this.onPause,
            complete: _this.onComplete,
            stop: _this.onStop,
            error: _this.onError,
            playerVolume: _this.onPlayerVolumeChange,
        };
        return _this;
    }
    return AudioMonitor;
}(Base_1.default)))();
